Controller.$inject = [];

function Controller() {

}

export function HuiInputSelectorContainer() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            multi: '<'
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `
                <div class="hui-input-selector-container" ng-transclude></div>
            `;
        }
    }
}